module.exports = __webpack_public_path__ + "img/AK0094-LU.cb0818a5.jpg";